import gql from 'graphql-tag';
import { AGENT_DETAILS_FRAGMENT } from 'listing-details/components/AgentDetails/AgentDetails.queries';
import { ENERGY_PERF_CERT_FRAGMENT } from 'listing-details/components/EnergyPerfCert/EnergyPerfCert.queries';
import { FLOOR_PLANS_FRAGMENT } from 'listing-details/components/FloorPlans/FloorPlans.queries';
import { TENANCY_INFO_FRAGMENT } from 'listing-details/components/TenancyInfo/TenancyInfo.queries';
import { VIRTUAL_TOURS_FRAGMENT } from 'listing-details/components/VirtualTours/VirtualTours.queries';
import { LISTING_FEATURES_FRAGMENT } from 'listing-details/components/ListingFeatures/ListingFeatures.queries';
import { LISTING_GALLERY_FRAGMENT } from 'listing-details/components/ListingGallery/ListingGallery.queries';
import { LISTING_HEAD_FRAGMENT } from 'listing-details/components/ListingHead/ListingHead.queries';
import { LISTING_INTERACTIVE_MAP_FRAGMENT } from 'listing-details/components/ListingInteractiveMap/ListingInteractiveMap.queries';
import { LISTING_MORE_INFORMATION_FRAGMENT } from 'listing-details/components/ListingMoreInformation/ListingMoreInformation.queries';
import { LISTING_NAVIGATION_FRAGMENT } from 'listing-details/components/ListingNavigation/ListingNavigation.queries';
import { LISTING_SHARING_FRAGMENT } from 'listing-details/components/ListingSharing/ListingSharing.queries';
import { LISTING_STATIC_MAP_FRAGMENT } from 'listing-details/components/ListingStaticMap/ListingStaticMap.queries';
import { LISTING_SUMMARY_DETAILS_FRAGMENT } from 'listing-details/components/ListingSummaryDetails/ListingSummaryDetails.queries';
import { LISTING_TAXONOMY } from 'listing-details/hooks/useListingPageTracking/useListingPageTracking.queries';
import { BREADCRUMBS_FRAGMENT } from 'listing-details/components/ListingBreadcrumbs/ListingBreadcrumbs.queries';
import { LISTING_ADDITIONAL_LINKS_FRAGMENT } from 'listing-details/components/AdditionalLinks/AdditionalLinks.queries';
import { LISTING_AMENITIES_FRAGMENT } from 'listing-details/components/ListingAmenities/ListingAmenities.queries';
import { MARKET_STATS_FRAGMENT } from 'listing-details/components/MarketStats/MarketStats.queries';
import { PRICE_HISTORY_FRAGMENT } from 'listing-details/components/ListingHistory/ListingHistory.queries';
import { SIMILAR_PROPERTIES_FRAGMENT } from 'listing-details/components/SimilarProperties/SimilarProperties.query';

export const LISTING_DETAILS_PAGE_FRAGMENT = gql`
    fragment LISTING_DETAILS_PAGE_FRAGMENT on ListingData {
        listingUris {
            detail
        }
        section
        marketStats {
            areaName
            areaNameUri
        }
        adTargeting {
            acorn
            acornType
            areaName
            bedsMax
            bedsMin
            branchId
            branchLogoUrl
            branchName
            brandName
            chainFree
            companyId
            countryCode
            countyAreaName
            currencyCode
            displayAddress
            furnishedState
            groupId
            hasEpc
            hasFloorplan
            incode
            isRetirementHome
            isSharedOwnership
            listingCondition
            listingId
            listingsCategory
            listingStatus
            location
            memberType
            numBaths
            numBeds
            numImages
            numRecepts
            outcode
            postalArea
            postTownName
            priceActual
            price
            priceMax
            priceMin
            priceQualifier
            propertyHighlight
            propertyType
            regionName
            section
            sizeSqFeet
            tenure
            zindex
        }
    }
`;

export const LISTING_QUERY = gql`
    query getListingDetails(
        $listingId: Int!
        $searchIdentifier: String
        $path: String!
    ) {
        listing(id: $listingId) {
            ...AGENT_DETAILS_FRAGMENT
            ...ENERGY_PERF_CERT_FRAGMENT
            ...FLOOR_PLANS_FRAGMENT
            ...TENANCY_INFO_FRAGMENT
            ...VIRTUAL_TOURS_FRAGMENT
            ...LISTING_DETAILS_PAGE_FRAGMENT
            ...LISTING_FEATURES_FRAGMENT
            ...LISTING_GALLERY_FRAGMENT
            ...LISTING_HEAD_FRAGMENT
            ...LISTING_INTERACTIVE_MAP_FRAGMENT
            ...LISTING_MORE_INFORMATION_FRAGMENT
            ...LISTING_SHARING_FRAGMENT
            ...LISTING_STATIC_MAP_FRAGMENT
            ...LISTING_SUMMARY_DETAILS_FRAGMENT
            ...LISTING_TAXONOMY
            ...LISTING_ADDITIONAL_LINKS_FRAGMENT
            ...LISTING_AMENITIES_FRAGMENT
            ...MARKET_STATS_FRAGMENT
            ...PRICE_HISTORY_FRAGMENT
            ...SIMILAR_PROPERTIES_FRAGMENT
        }
        backToResultsLink(id: $listingId, searchIdentifier: $searchIdentifier) {
            ...LISTING_NAVIGATION_FRAGMENT
        }
        breadcrumbs(path: $path) {
            ...BREADCRUMBS_FRAGMENT
        }
    }
    ${AGENT_DETAILS_FRAGMENT}
    ${ENERGY_PERF_CERT_FRAGMENT}
    ${FLOOR_PLANS_FRAGMENT}
    ${TENANCY_INFO_FRAGMENT}
    ${VIRTUAL_TOURS_FRAGMENT}
    ${LISTING_DETAILS_PAGE_FRAGMENT}
    ${LISTING_FEATURES_FRAGMENT}
    ${LISTING_GALLERY_FRAGMENT}
    ${LISTING_HEAD_FRAGMENT}
    ${LISTING_INTERACTIVE_MAP_FRAGMENT}
    ${LISTING_MORE_INFORMATION_FRAGMENT}
    ${LISTING_SHARING_FRAGMENT}
    ${LISTING_STATIC_MAP_FRAGMENT}
    ${LISTING_SUMMARY_DETAILS_FRAGMENT}
    ${LISTING_NAVIGATION_FRAGMENT}
    ${LISTING_TAXONOMY}
    ${LISTING_AMENITIES_FRAGMENT}
    ${BREADCRUMBS_FRAGMENT}
    ${LISTING_ADDITIONAL_LINKS_FRAGMENT}
    ${MARKET_STATS_FRAGMENT}
    ${PRICE_HISTORY_FRAGMENT}
    ${SIMILAR_PROPERTIES_FRAGMENT}
`;

export const REDIRECT_QUERY = gql`
    query getRedirects($path: String!) {
        redirects(path: $path) {
            code
            redirectUri
        }
    }
`;
